import $ from 'jquery';
import debug from 'debug';

const log = debug('siisel:datatables:buttons:excelExport');

const internal = $.fn.DataTable.ext.internal;
const DataTable = $.fn.DataTable;

DataTable.ext.buttons.backendExcelExport = {
    name: 'backendExcelExport',
    className: 'excel-export',
    header: true,
    footer: false,
    text: function (dt) {
        return dt.i18n('buttons.backendExcelExport',
            `<i class="fa fa-download" /><i class="fa fa-refresh fa-spin" />&nbsp;Excel`);
    },
    action: function (_e, dt) {
        log('Excel Export button clicked');

        const settings = dt.context[0];
        const args = internal._fnAjaxParameters(settings);
        let url = settings.ajax.url.replace('/odata/', '/export/')
        const filter = args.columns.filter(x => x.searchable && x.search.value !== '').reduce((acc, cur) => {
            acc[cur.data] = cur.search.value;
            return acc;
        }, {});

        const tableName = (new URL(settings.ajax.url)).pathname.split("/")[2];
        const negativeFilterColumns = $("input.negative-filter-" + tableName + "[value='1']")
            .toArray()
            //.filter(element => settings.ajax.url.startsWith(element.attributes["data-url"].value))
            .map(element => element.attributes["data-column"].value)
            .join(',');

        const params = $.param({ filter: filter, negative: negativeFilterColumns});
        if (url.indexOf("?") === -1) {
            url += "?" + params;
        } else {
            url += "&" + params;
        }

        console.log(jQuery().jquery);
        $.ajax(url, { method: 'POST', async: true })
            .error(function (x, status, error) {
                console.log('AJAX ERROR: ' + status);
            })
            .success(function (data, status, x) {
                console.log('AJAX RESULT: ' + status);
            });
    }
};



// WEBPACK FOOTER //
// ./App/components/datatable/buttons/excelExport.js